import { TimeFilter } from "enums/transaction";
import moment from "moment";

interface DateRange {
  start: string;
  end: string;
}

export const generateDateRange = (value: TimeFilter) => {
  const startDateFormat = "YYYY-MM-DD";
  const endDateFormat = "YYYY-MM-DD";
  let result: DateRange = {
    start: "",
    end: "",
  };
  switch (value) {
    case TimeFilter.TODAY:
      result = {
        start: moment().format(startDateFormat),
        end: moment().format(endDateFormat),
      };
      break;
    case TimeFilter.YESTERDAY:
      result = {
        start: moment().add(-1, "days").format(startDateFormat),
        end: moment().add(-1, "days").format(endDateFormat),
      };
      break;
    case TimeFilter.THIS_WEEK:
      result = {
        start: moment().add(-7, "days").format(startDateFormat),
        end: moment().format(endDateFormat),
      };
      break;
    case TimeFilter.THIS_MONTH:
      result = {
        start: moment().add(-30, "days").format(startDateFormat),
        end: moment().format(endDateFormat),
      };
      break;
    default:
      break;
  }
  return result;
};
